import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UpdateContractClosingDateSchema } from '@/features/privateCompanies/schemas/contract/updateContractClosingDate.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateContractClosingDate {
  contractId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateContractClosingDate = ({ contractId, onSuccess, onError }: UseUpdateContractClosingDate) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContractClosingDate'],
    mutationFn: async (data: UpdateContractClosingDateSchema) => {
      await privateAxios.put(`/client/contracts/${contractId}/update_closing_date`, {
        ...data,
      })
    },
    onSuccess,
    onError,
  })
}
